import { useLocation } from 'react-router-dom'
import { FileCode2 } from 'lucide-react'

/**
 * Página exibida quando a rota existe no menu mas ainda não tem implementação.
 * Novas opções de menu aparecem após relogin e, ao clicar, mostram esta página
 * até que a rota seja implementada em App.tsx.
 */
export function PaginaDefault() {
  const { pathname } = useLocation()

  return (
    <div className="p-6 flex flex-col items-center justify-center min-h-[60vh]">
      <div className="w-16 h-16 rounded-full bg-brand-100 flex items-center justify-center mb-4">
        <FileCode2 className="w-8 h-8 text-brand-500" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Página em desenvolvimento</h1>
      <p className="text-gray-600 text-center max-w-md mb-1">
        A rota <code className="px-1.5 py-0.5 bg-gray-100 rounded text-sm font-mono">{pathname}</code> foi criada no menu e será implementada posteriormente.
      </p>
      <p className="text-sm text-gray-500">
        Adicione o componente e a rota em <code className="text-xs bg-gray-100 px-1 rounded">App.tsx</code> quando for desenvolver esta tela.
      </p>
    </div>
  )
}
